import { MdLockOutline } from 'react-icons/md';

import { useCheckout } from 'features/events/checkout/context';
import TierCategory from './components/TierCategory';
import Spinner, { SpinnerType } from 'legacy/common/components/spinner/Spinner';
import { CheckoutSteps } from 'features/events/checkout/types';
import { useTranslation } from 'react-i18next';

const Tiers = () => {
  const { t } = useTranslation(['checkout']);
  const { ticketTiers, addonTiers, currentStep } = useCheckout();

  const isAddonStep = currentStep === CheckoutSteps.TicketTiersAddon;
  const activeTiers = isAddonStep ? addonTiers : ticketTiers;

  if (
    activeTiers.isLoadingProducts ||
    activeTiers.isLoadingUnauthenticatedProducts
  ) {
    return (
      <div className="flex-1 md:w-2/3">
        <div className="mt-10 p-12 text-center text-base text-gray-500 font-normal">
          <Spinner type={SpinnerType.PRIMARY} />
        </div>
      </div>
    );
  }

  if (
    activeTiers.sortedTicketTiers?.length === 0 &&
    activeTiers.filteredSections?.length === 0 &&
    activeTiers.privateTiers?.length === 0
  ) {
    return (
      <div className="flex-1 md:w-2/3">
        <div className="mt-10 p-12 text-center text-base text-gray-500 font-normal">
          {t('checkout:noPublicTickets')}
        </div>
      </div>
    );
  }

  return (
    <div className="flex-1 md:w-2/3">
      {isAddonStep && (
        <h1 className="text-2xl font-semibold ml-4 pt-8 pb-10">
          {t('checkout:treatYourself')}
        </h1>
      )}

      {/* Private section for private tickets */}
      {activeTiers.privateTiers && activeTiers.privateTiers.length > 0 && (
        <TierCategory
          id="private"
          title={
            <>
              <MdLockOutline size={18} />
              {t('checkout:private')}
            </>
          }
          tiers={activeTiers.privateTiers}
        />
      )}

      {activeTiers.filteredSections?.map((section) => {
        const sectionTiers = activeTiers.ticketsBySection?.[section.id];
        if (!sectionTiers || sectionTiers.length === 0) {
          return null;
        }

        return (
          <TierCategory
            key={section.id}
            id={section.id}
            title={section.name}
            tiers={sectionTiers}
          />
        );
      })}

      {/* Default section for tickets without sectionId */}
      {activeTiers.ticketsBySection?.default &&
        activeTiers.ticketsBySection.default.length > 0 && (
          <TierCategory
            id="uncategorized"
            title={
              activeTiers.filteredSections.length > 0
                ? t('checkout:uncategorized')
                : null
            }
            tiers={activeTiers.ticketsBySection.default}
          />
        )}
    </div>
  );
};

export default Tiers;
